import { render, staticRenderFns } from "./OpenHouse.vue?vue&type=template&id=97a947ae&scoped=true"
import script from "./OpenHouse.vue?vue&type=script&lang=js"
export * from "./OpenHouse.vue?vue&type=script&lang=js"
import style0 from "./OpenHouse.vue?vue&type=style&index=0&id=97a947ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a947ae",
  null
  
)

export default component.exports